// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal overlay */
.react-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.react-modal-content {
  position: relative;
  background-color: #fff;
  padding: 2rem;
  border-radius: 0.3rem;
  max-width: 600px;
  width: auto;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  outline: none;
  margin: 1rem; /* Margin to prevent sticking to the edges */
  overflow: hidden;
}

@media (max-width: 768px) {
  .react-modal-content {
    width: 90%; /* Occupy most of the screen on small devices */
    margin: 10% auto; /* Increase margin on the top and bottom */
    max-height: 70vh; /* Limit the height on small screens */
    overflow-y: auto; /* Enable vertical scrolling if content is too long */
  }
}

/* Modal header */
.modal-header {
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 1.5rem;
  text-align: center;
}

/* Form elements */
input, select, textarea {
  width: 100%;
  padding: 0.5rem;
  margin: 0.5rem 0;
  margin-bottom: 1rem;
  border: 1px solid #ccc;
  border-radius: 0.25rem;
  font-size: 1rem;
  color: #333;
  box-sizing: border-box;
}

/* Buttons */
button {
  padding: 0.75rem 1.5rem;
  margin-right: 0.5rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  margin-left: 0.5rem;
  border: 1px black; 
  border-radius: 0.25rem;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}

/* .button {
  border: 1px solid black;
  transition: border-color 0.2s; 
}

.button:hover, .button.selected {
  
}

.survey-button:hover, .survey-button.selected {
  border-color: #ff8159;
}

.install-button:hover, .install-button.selected {
  border-color: #589cc1;
} */

/* Button colors */
.save-button {
  background-color: #4CAF50;
  color: white;
}

.clear-button {
  background-color: #a09f9e;
  color: white;
  height: 42px;
}

.close-button {
  background-color: #0c3274;
  color: white;
}

button:hover {
  opacity: 0.85;
}

/* Utility classes */
.hidden {
  display: none;
}

`, "",{"version":3,"sources":["webpack://./src/pages/calendar/CreateEventModal.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,yCAAyC;EACzC,aAAa;EACb,YAAY,EAAE,4CAA4C;EAC1D,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU,EAAE,+CAA+C;IAC3D,gBAAgB,EAAE,0CAA0C;IAC5D,gBAAgB,EAAE,sCAAsC;IACxD,gBAAgB,EAAE,qDAAqD;EACzE;AACF;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA,YAAY;AACZ;EACE,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;;;;;;;;;;;;;;;GAeG;;AAEH,kBAAkB;AAClB;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,aAAa;AACf","sourcesContent":["/* Modal overlay */\n.react-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.react-modal-content {\n  position: relative;\n  background-color: #fff;\n  padding: 2rem;\n  border-radius: 0.3rem;\n  max-width: 600px;\n  width: auto;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n  outline: none;\n  margin: 1rem; /* Margin to prevent sticking to the edges */\n  overflow: hidden;\n}\n\n@media (max-width: 768px) {\n  .react-modal-content {\n    width: 90%; /* Occupy most of the screen on small devices */\n    margin: 10% auto; /* Increase margin on the top and bottom */\n    max-height: 70vh; /* Limit the height on small screens */\n    overflow-y: auto; /* Enable vertical scrolling if content is too long */\n  }\n}\n\n/* Modal header */\n.modal-header {\n  font-size: 1.5rem;\n  color: #333;\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\n/* Form elements */\ninput, select, textarea {\n  width: 100%;\n  padding: 0.5rem;\n  margin: 0.5rem 0;\n  margin-bottom: 1rem;\n  border: 1px solid #ccc;\n  border-radius: 0.25rem;\n  font-size: 1rem;\n  color: #333;\n  box-sizing: border-box;\n}\n\n/* Buttons */\nbutton {\n  padding: 0.75rem 1.5rem;\n  margin-right: 0.5rem;\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n  margin-left: 0.5rem;\n  border: 1px black; \n  border-radius: 0.25rem;\n  font-size: 1rem;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out;\n}\n\n/* .button {\n  border: 1px solid black;\n  transition: border-color 0.2s; \n}\n\n.button:hover, .button.selected {\n  \n}\n\n.survey-button:hover, .survey-button.selected {\n  border-color: #ff8159;\n}\n\n.install-button:hover, .install-button.selected {\n  border-color: #589cc1;\n} */\n\n/* Button colors */\n.save-button {\n  background-color: #4CAF50;\n  color: white;\n}\n\n.clear-button {\n  background-color: #a09f9e;\n  color: white;\n  height: 42px;\n}\n\n.close-button {\n  background-color: #0c3274;\n  color: white;\n}\n\nbutton:hover {\n  opacity: 0.85;\n}\n\n/* Utility classes */\n.hidden {\n  display: none;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
